<template>
  <div class="panel-right" id="PANELRIGHT-SWF">

    <!-- 折叠/展开按钮（对齐PAGE-SWF右侧按钮交互：合上滑出右缘仅留按钮，展开贴回） -->
    <i class="fold-btn" :class="folded ? 'el-icon-arrow-left' : 'el-icon-arrow-right'" @click="handleFold"></i>

    <div class="title" v-if="platform != 'qt'"></div>
    <div class="title_action" v-if="platform != 'qt'">动作</div>

    <!-- 切换标签组件 tabs-panel -->
    <div class="tabs-panel">
      <div class="item" v-for="item, index in tabs_data">
        <i :class="item.icon"></i>
        <div class="name">{{item.name}}</div>
      </div>
    </div>

    <div class="panel-group">
      <div class="panel">
        <material></material>
      </div>

      <div class="panel">
        <action></action>
      </div>

      <div class="panel">
        <camera></camera>
      </div>

      <div class="panel">
        <euy-text></euy-text>
      </div>

      <div class="panel">
        <euy-audio></euy-audio>
      </div>

      <div class="panel">
          <align></align>
      </div>

      <div class="panel">
        <step></step>
      </div>

      <div class="panel">
        <action-info></action-info>
      </div>

      <div class="panel">
        <parts></parts>
      </div>
    </div>

  </div>
</template>

<script>

  // 动作市场组件
  import Action from '@/components/Action/Action'
  // 动作设置组件
  import ActionInfo from '@/components/ActionInfo/ActionInfo'
  // 部件组件
  import Parts from '@/components/Parts/Parts'
  // 镜头组件
  import Camera from '@/components/Camera/Camera'
  // 文字组件
  import EuyText from '@/components/Text/Text'
  // 属性组件
  import Step from '@/components/Step/Step'
  //对齐
  import Align from '@/components/Align/Align'
  // 声音组件
  import EuyAudio from '@/components/AudioPanel/AudioPanel'

  // 素材市场组件
  import Material from '@/components/Material/Material'

  // 通讯协议
  import Protocol from '@/common/scripts/protocol.js'

  import EUY from '@/common/scripts/euy'

  export default {
    components: {
      Action,
      ActionInfo,
      Parts,
      Camera,
      EuyText: EuyText,
      Step,
      Align,
      EuyAudio: EuyAudio,
      Material
    },
    data () {
      return {
        platform: this.$route.query.platform,
        tabs_data: [
          { name: '素材', icon: 'icon-material', active: false },
          { name: '动作', icon: 'icon-action', active: false },
          { name: '镜头', icon: 'icon-nav_scene', active: false },
          { name: '文字', icon: 'icon-nav_text', active: false },
          { name: '声音', icon: 'icon-nav_voice', active: false },
          { name: '样式', icon: 'icon-nav_action_type', active: false},
          { name: '属性', icon: 'icon-nav_attribute', active: false },
          { name: '设置', icon: 'icon-actioninfo', active: false },
          { name: '部件', icon: 'icon-parts', active: false }
        ],

        // 右侧面板是否合上（滑出屏幕右缘，仅留折叠按钮）
        folded: false
      }
    },
    methods: {
      // 程序化展开（面板合上时由模块消息触发，如点选形象自动开面板）：
      // 外部代码只改了 width/right，folded 状态需在这里同步复位
      open () {
        if (this.folded) {
          this.handleFold()
        }
      },
      // 展开/合上右侧面板：对齐PAGE-SWF折叠按钮交互
      handleFold () {
        let panel = $('#PANELRIGHT-SWF')
        let scene = $('.scene-container')
        let editor_timeline = $('.editor-timeline-container')
        let action_timeline = $('.action-timeline-container')
        // width(): 280=面板展开, 0=仅标签条；加56为标签条宽度
        let w = panel.width()
        if (this.folded) {
          // 展开：贴回右缘，恢复动画区/时间轴右侧间距
          let inset = w > 0 ? 336 : 50
          panel.css({ right: 0 })
          scene.css({ right: inset })
          editor_timeline.css({ right: inset })
          action_timeline.css({ right: inset })
          this.folded = false
        } else {
          // 合上：整体滑出屏幕右缘，按钮（left:-12）仍留在屏幕内可点击
          panel.css({ right: -(w + 56) })
          scene.css({ right: 0 })
          editor_timeline.css({ right: 0 })
          action_timeline.css({ right: 0 })
          this.folded = true
        }
        // 通知时间轴/eu-core画布重算尺寸
        setTimeout(() => {
          $(window).trigger('resize')
        }, 50)
      }
    },
    mounted () {

      let platform = this.$route.query.platform

      this.platform = platform

      // PANELRIGHT
      // 模块初始化
      Protocol.onSocketInit(platform, PANELRIGHT_NAME, PANELRIGHT)
      // 模块与服务器建立链接
      Protocol.onSocketConnect(platform, PANELRIGHT_NAME)
      // 模块与服务器建立链接
      Protocol.onSocketRegister(platform, PANELRIGHT_NAME, PANELRIGHT)
      // 接收消息
      Protocol.receiver(platform, PANELRIGHT_NAME)
      // 接收消息模块
      window[PANELRIGHT_NAME].message = function (senderId, packageId, sessionId, messageId, protoBytes) {

        if(sessionId == 6 && messageId == 5) {

          console.log('[' + PANELRIGHT_NAME + '][COMPLETE]')

        }

      }

      // 面板合上时，引擎消息（点选形象/进入动作编辑等）通过该事件把面板展开并复位folded
      $(window).on('panelright.open', () => this.open())

    },
    beforeDestroy () {
      $(window).off('panelright.open')
    }
  }
</script>

<style lang="stylus" scoped>
  .panel-right
    background:#323232//#e8e8e8
    position: absolute
    top: 0
    right: 0
    bottom: 0
    width: 0
    padding-right: 56px
    .fold-btn
      position absolute
      left -12px
      top 45%
      margin-top -15px
      width 12px
      height 30px
      line-height 30px
      text-align center
      cursor pointer
      background #c9c9c9
      color #fff
      z-index 3
      &:hover
        background #e1e1e1
      &:active
        background #949494
    .mask
      position: absolute
      top: 25px
      right: 0
      bottom: 0
      left: 0
      width: 280px
      background: #3a3a3a//rgba(255, 255, 255,.8)
      z-index: 1
    .title
      background: #303030//#a6a6a6
      line-height: 25px
      text-align: center
      color: #e2e2e2//#3f3f3f
    .title_action
      width: 280px
      background: #323232//#a6a6a6
      line-height: 25px
      text-align: center
      color: #e2e2e2//#3f3f3f
      position: absolute
      top: 0
      left: 0
      z-index: -1
    .tabs-panel
      position: absolute
      right: 0
      top: 0
      bottom: 0
      width: 56px
      background:#323232//#f0f0f0
      z-index: 2
      overflow: hidden
      .item
        width: 56px
        height: 56px
        cursor: pointer
        i
          width: 56px
          height: 32px
          line-height: 32px
          display: block
          text-align: center
          font-size: 24px
          color:#fff//#545454
        .name
          text-align: center
          font-size: 12px
          -webkit-transform: scale(0.8)
          color:#e2e2e2
        &:hover
          background: #595959//#5c5c5c  
      .active
          background: #dbdbdb
          .name
           color:#000
          i
            color:#000 
          &:hover
            background:#dbdbdb
    .panel
      position: absolute
      top: 25px
      right: 0
      bottom: 0
      left: 0
      width: 280px
      z-index: 1
      overflow: hidden
</style>



// WEBPACK FOOTER //
// PanelRight.vue?eca8b082